import { Controller } from "@hotwired/stimulus"
import DateRangePicker from 'flowbite-datepicker/DateRangePicker';

export default class extends Controller {
  connect() {
    this.flowbiteDatePicker = new DateRangePicker(this.element, {
        autohide: this.element.hasAttribute("datepicker-autohide"),
        format: this.element.getAttribute("datepicker-format")
    });
  }
}